var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsernameLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6666C12.3012 11.6666 14.1667 9.80117 14.1667 7.49998C14.1667 5.19879 12.3012 3.33331 10 3.33331C7.69885 3.33331 5.83337 5.19879 5.83337 7.49998C5.83337 9.80117 7.69885 11.6666 10 11.6666ZM10 11.6666C6.31814 11.6666 3.33337 13.9052 3.33337 16.6666M10 11.6666C13.6819 11.6666 16.6667 13.9052 16.6667 16.6666",
    stroke: "#9599A1",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsernameLogin);
export default __webpack_public_path__ + "static/media/username-login.805dea39ea0f965b20f4df690cab39ec.svg";
export { ForwardRef as ReactComponent };